// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"382":"28843fee","493":"6e194560","631":"a744844f"}[chunkId] + ".chunk.js";
};